export const GET_MARKETS = "GET_MARKETS";
export const GET_MARKET_BY_ID = "GET_MARKET_BY_ID";
export const UPDATE_MARKET = "UPDATE_MARKET";
export const DELETE_MARKET = "DELETE_MARKET";
export const CREATE_MARKET = "CREATE_MARKET";
